import { V3Dropdown } from "../Dropdown"
import { V3IconCalendar } from "../Icons"
import { V3TextInput } from "../TextInput/V3TextInput"
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from "react";
import { V3DatePanelContent, V3DPresetDropdownRow } from "./V3Date.styles";
import { V3Body } from "../Typography";
import { DateStates, getV3DateText, isDateActive, V3_DATE_PRESETS } from "./V3Date.utils";
import { theme } from "../../theme/theme";

interface V3DateProps {
    useRange?: boolean,
    onDateSet?: (startDate: DateStates, endDate: DateStates) => void,
    start?: DateStates,
    end?: DateStates,
}

export const V3Date = ({ useRange = false, onDateSet, start, end }: V3DateProps) => {
    const [startDate, setStartDate] = useState<DateStates>(start ? start : null);
    const [endDate, setEndDate] = useState<DateStates>(end ? end : null);

    useEffect(() => {
        if (start !== startDate) setStartDate(start);
        if (end !== endDate) setEndDate(end);
    }, [start, end]);

    return <>
        <V3Dropdown
            maxWidth={815}
            renderReferenceElement={() =>
                <div style={{ pointerEvents: "none" }}>
                    <V3TextInput
                        disabled
                        value={getV3DateText(startDate, endDate, useRange)}
                        icon={<V3IconCalendar />}
                        style={{ color: theme.v3.colors.grey48, WebkitTextFillColor: theme.v3.colors.grey48, opacity: 1, cursor: "pointer" }}
                    />
                </div>}
            renderPopperElement={(_open, setOpen) => {
                return <V3DatePanelContent hasBorder={useRange}>
                    <div suppressHydrationWarning>
                        {
                            useRange && V3_DATE_PRESETS.map(presetData => <V3DPresetDropdownRow
                                key={presetData.label}
                                active={isDateActive(presetData.start, presetData.end, startDate, endDate)}
                                onClick={() => {
                                    setStartDate(presetData.start);
                                    setEndDate(presetData.end);
                                    onDateSet && onDateSet(presetData.start, presetData.end);
                                    setOpen(false);
                                }}
                            >
                                <V3Body>{presetData.label}</V3Body>
                            </V3DPresetDropdownRow>)
                        }
                    </div>
                    <div suppressHydrationWarning>
                        <div >
                            {useRange ? (
                                <DatePicker
                                    selected={startDate}
                                    disabledKeyboardNavigation
                                    onChange={([start, end]) => {
                                        setStartDate(start);
                                        setEndDate(end);

                                        if (start && end) {
                                            onDateSet && onDateSet(start, end);
                                            setOpen(false);
                                        }
                                    }}
                                    startDate={startDate}
                                    endDate={endDate}
                                    selectsRange
                                    inline
                                    monthsShown={2}
                                />
                            ) : (
                                <DatePicker
                                    selected={startDate}
                                    disabledKeyboardNavigation
                                    onChange={(date) => {
                                        setStartDate(date);
                                        onDateSet && onDateSet(date, undefined);
                                        setOpen(false);
                                    }}
                                    startDate={startDate}
                                    inline
                                    monthsShown={1}
                                />
                            )}
                        </div>
                    </div>
                </V3DatePanelContent>
            }}
            strategy="fixed"
            placement="bottom-start"
        />
    </>
}